import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Link from 'next/link'

import { AppStore, Instagram, Twitter, Facebook, Logo } from 'components/common'
import s from './Footer.module.css'

const Footer = () => {
  const { data } = useSelector((state) => state.footer.footerLinks)
  const regions = useSelector((state) => state.homepage.regions.data)
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    setIsIOS(isTouchDevice);
  }, []);

  const sortedRegions = [...regions].sort(function (a, b) {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  return (
    <footer className={s.footer}>
      <div className={s.linksArea}>
        <div className={s.leftArea}>
          <Logo width="166px" height="61px" />

          <div>
            <a
              href={'https://apps.apple.com/us/app/caribeeats/id1462589124'}
              target="_blank"
              className={s.appStore}
            >
              <AppStore width={136} height={41} />
            </a>

            {!isIOS && <a
              target="_blank"
              href={
                'https://play.google.com/store/apps/details?id=com.caribeeats.consumer'
              }
            >
              <img
                className={s.googlePlay}
                src="/GooglePlay.png"
                alt="google-play"
                width={136}
                height={41}
              />
            </a>}
          </div>
        </div>

        {!!sortedRegions.length && (
          <div className={s.locationsWrapper}>
            <h4 className={s.deliveryLocations}>Delivery Locations</h4>

            <ul className={s.boldList}>
              {sortedRegions.map((region) => (
                <li key={region.id}>
                  <Link href={`/services/${region.slug}`}>
                    <a>{region.name}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        <ul className={s.list}>
          {data.left?.map((item, index) => (
            <li key={`left-${index}`}>
              <a target="_blank" href={item.content}>
                {item.name}
              </a>
            </li>
          ))}
        </ul>

        <ul className={s.list}>
          {data.right?.map((item, index) => (
            <li key={`right-${index}`}>
              <a target="_blank" href={item.content}>
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <hr className={s.divider} />

      <div className={s.iconsWrapper}>
        <a href="https://facebook.com/caribeeatsapp" target="_blank">
          <Facebook />
        </a>
        <a href="https://twitter.com/CaribeEats" target="_blank">
          <Twitter />
        </a>
        <a href="https://www.instagram.com/caribeeatsapp/" target="_blank">
          <Instagram />
        </a>
      </div>
    </footer>
  )
}

export default Footer
